(function ($, window) {
    "use strict";

    if (document.location.href.indexOf('cmsPreview') < 0) {
        return;
    }

    window.mobilePreview = window.mobilePreview ? window.mobilePreview : {};

    /**
     * @const
     */
    var CSS_ID = '#mobile-style-use-css';

    var $userCssStyle;

    window.mobilePreview.usercss = {
        init: function () {
            $userCssStyle = $(CSS_ID);

            return this;
        },

        updateUserCss: function (data) {
            if ($userCssStyle.length) {
                $userCssStyle.remove();
            }
            $userCssStyle = $(createStyle(CSS_ID, data)).attr('disabled', false).appendTo("head");
        },

        disableUserCss:function(){
            $userCssStyle.attr('disabled', true);
        }
    };

    /**
     * createStyle:
     */
    function createStyle(id, inlineStyle) {
        if (!inlineStyle || !id) {
            return;
        }

        var style = '<style type="text/css" id="' + id + '">' +
            '/* <![CDATA[ */' +
            inlineStyle +
            '/* ]]> */' +
            '</style>';

        return style;
    }

})(jQuery, window);



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobileUserCss.js
 ** module id = 3806
 ** module chunks = 100
 **/